import { render, staticRenderFns } from "./MatchRow.vue?vue&type=template&id=713e35de&scoped=true&"
import script from "./MatchRow.vue?vue&type=script&lang=js&"
export * from "./MatchRow.vue?vue&type=script&lang=js&"
import style0 from "./MatchRow.vue?vue&type=style&index=0&id=713e35de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713e35de",
  null
  
)

export default component.exports